/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate } from "react-router-dom";
import { Button, IconButton, MenuItem, Select, Tabs, Tab, Box, Checkbox, ListItemText } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import GroupsIcon from "@mui/icons-material/Groups";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import SearchBar from "../../../components/SearchBar";
import NewPolicy from "../../../Modals/newPolicy";
import ViewPolicyDetail from "../../../Modals/viewPolicyDetail";
import { useState } from "react";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const ComlpliancePolicies = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    const [tabValue, setTabValue] = useState(0);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [selectedPolicy, setSelectedPolicy] = useState<any>(null);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    const policies = [
        {
            title: "Data Privacy Policy",
            code: "POL-PRV-001",
            description: "Comprehensive policy governing the collection, processing, and storage of personal data",
            owner: "Sarah Chen",
            version: "2.1",
            effective: "1/1/2024",
            reviewDate: "1/1/2025",
            status: "Active",
            review: "Review Due",
            category: "Privacy",
            icon: <DescriptionOutlinedIcon />,
            isOverdue: true,
            content: "This policy establishes the framework for protecting personal data in accordance with GDPR, CCPA, and other applicable regulations...",
            scope: "All employees, contractors, and third-party partners handling customer data",
            dataCollection: "Customer names, contact details, transaction history, and behavioral data",
            dataProcessing: "Data is processed for order fulfillment, customer support, and marketing purposes with explicit consent"
        },
        {
            title: "Cookie Consent Policy",
            code: "POL-PRV-002",
            description: "Guidelines for cookie usage and user consent management",
            owner: "Sarah Chen",
            version: "1.5",
            effective: "3/1/2024",
            reviewDate: "3/1/2025",
            status: "Active",
            review: "Up to date",
            category: "Privacy",
            icon: <DescriptionOutlinedIcon />,
            isOverdue: false,
            content: "Guidelines for implementing tracking tokens and managing user preferences...",
            scope: "Web and Mobile applications",
            dataCollection: "Browser info, IP address, Device ID",
            dataProcessing: "Used for session management and analytics"
        },
        {
            title: "Information Security Policy",
            code: "POL-SEC-001",
            description: "Enterprise wide security controls and requirements",
            owner: "Michael Roberts",
            version: "3.0",
            effective: "1/15/2024",
            reviewDate: "1/15/2025",
            status: "Active",
            review: "Review Due",
            category: "Security",
            icon: <SecurityOutlinedIcon />,
            isOverdue: true,
            content: "Defines the technical and administrative controls for securing the corporate network...",
            scope: "Corporate infrastructure and remote working environments",
            dataCollection: "System logs, access attempts, security events",
            dataProcessing: "Real-time monitoring and threat detection"
        },
        {
            title: "Access Control Policy",
            code: "POL-SEC-002",
            description: "Policies for internal and external system access management",
            owner: "Michael Roberts",
            version: "2.0",
            effective: "2/10/2024",
            reviewDate: "2/10/2025",
            status: "Active",
            review: "Up to date",
            category: "Security",
            icon: <LockOutlinedIcon />,
            isOverdue: false,
            content: "Standards for password management and multi-factor authentication...",
            scope: "All internal systems and SaaS platforms",
            dataCollection: "User credentials and access levels",
            dataProcessing: "Authentication and authorization checks"
        },
        {
            title: "Vendor Management Policy",
            code: "POL-LEG-001",
            description: "Requirements for third party vendor compliance",
            owner: "Jennifer Adams",
            version: "1.0",
            effective: "4/1/2024",
            reviewDate: "4/1/2025",
            status: "Active",
            review: "Up to date",
            category: "Legal",
            icon: <BusinessOutlinedIcon />,
            isOverdue: false,
            content: "Framework for evaluating and monitoring vendor performance and risk...",
            scope: "All procurement and vendor relationship managers",
            dataCollection: "Vendor certifications, SOC reports, performance metrics",
            dataProcessing: "Compliance auditing and risk assessment"
        },
        {
            title: "Encryption Policy",
            code: "POL-SEC-003",
            description: "Standards for data encryption at rest and in transit",
            owner: "Michael Roberts",
            version: "2.0",
            effective: "6/1/2023",
            reviewDate: "6/1/2024",
            status: "Under Review",
            review: "Up to date",
            category: "Security",
            icon: <GavelOutlinedIcon />,
            isOverdue: false,
            content: "Requirements for using AES-256 for data at rest and TLS 1.3 for data in transit...",
            scope: "All databases, file servers, and API endpoints",
            dataCollection: "Encryption keys and security certificates",
            dataProcessing: "Cryptographic operations across the stack"
        },
        {
            title: "Incident Response Plan",
            code: "POL-OPS-001",
            description: "Procedures for handling operational security incidents",
            owner: "Kevin Smith",
            version: "1.2",
            effective: "5/12/2023",
            reviewDate: "5/12/2024",
            status: "Active",
            review: "Up to date",
            category: "Operational",
            icon: <BusinessCenterOutlinedIcon />,
            isOverdue: false,
            content: "Step-by-step instructions for identifying, containing, and eradicating threats...",
            scope: "IT, Security, and Legal response teams",
            dataCollection: "Forensic snapshots, network pcaps, system logs",
            dataProcessing: "Investigation and root cause analysis"
        },
        {
            title: "AI Ethics Guidelines",
            code: "POL-AI-001",
            description: "Ethical standards for artificial intelligence development and use",
            owner: "AI Governance Board",
            version: "1.0",
            effective: "10/01/2024",
            reviewDate: "10/01/2025",
            status: "Active",
            review: "Up to date",
            category: "AI Governance",
            icon: <SmartToyOutlinedIcon />,
            isOverdue: false,
            content: "Principles of fairness, transparency, and accountability in AI systems...",
            scope: "AI research and engineering departments",
            dataCollection: "Training datasets and model parameters",
            dataProcessing: "Bias auditing and model validation"
        },
        {
            title: "Model Transparency Policy",
            code: "POL-AI-002",
            description: "Requirements for AI model documentation and explainability",
            owner: "AI Governance Board",
            version: "1.0",
            effective: "11/15/2024",
            reviewDate: "11/15/2025",
            status: "Under Review",
            review: "Up to date",
            category: "AI Governance",
            icon: <SmartToyOutlinedIcon />,
            isOverdue: false,
            content: "Guidelines for creating model cards and system documentation...",
            scope: "All production-ready AI models",
            dataCollection: "Model architecture and performance metrics",
            dataProcessing: "Documentation generation and stakeholder review"
        },
        {
            title: "Anti-Bribery Policy",
            code: "POL-LEG-002",
            description: "Corporate guidelines on anti-corruption and bribery prevention",
            owner: "Jennifer Adams",
            version: "2.0",
            effective: "01/10/2024",
            reviewDate: "01/10/2025",
            status: "Active",
            review: "Up to date",
            category: "Legal",
            icon: <GavelOutlinedIcon />,
            isOverdue: false,
            content: "Zero-tolerance approach to bribery and corruption...",
            scope: "Global operations",
            dataCollection: "Financial records, gift logs",
            dataProcessing: "Internal auditing and compliance monitoring"
        },
        {
            title: "Intellectual Property Policy",
            code: "POL-LEG-003",
            description: "Protection and management of company intellectual property assets",
            owner: "Jennifer Adams",
            version: "1.1",
            effective: "03/20/2024",
            reviewDate: "03/20/2025",
            status: "Active",
            review: "Up to date",
            category: "Legal",
            icon: <BusinessOutlinedIcon />,
            isOverdue: false,
            content: "Ownership and protection of software, brands, and inventions...",
            scope: "Employees and contractors",
            dataCollection: "IP filings, employee agreements",
            dataProcessing: "IP portfolio management"
        },
        {
            title: "Algorithmic Bias Policy",
            code: "POL-AI-003",
            description: "Mitigation strategies for bias in AI algorithms and datasets",
            owner: "AI Governance Board",
            version: "1.0",
            effective: "12/01/2024",
            reviewDate: "12/01/2025",
            status: "Active",
            review: "Up to date",
            category: "AI Governance",
            icon: <SmartToyOutlinedIcon />,
            isOverdue: false,
            content: "Protocols for identifies and reducing algorithmic bias...",
            scope: "Machine learning engineering",
            dataCollection: "Dataset demographics, model output distributions",
            dataProcessing: "Fairness metric evaluation"
        }
    ];

    const handleRowClick = (policy: any) => {
        setSelectedPolicy(policy);
        setOpenViewModal(true);
    };

    const counts = {
        All: policies.length,
        Privacy: policies.filter(p => p.category === "Privacy").length,
        Security: policies.filter(p => p.category === "Security").length,
        Operational: policies.filter(p => p.category === "Operational").length,
        Legal: policies.filter(p => p.category === "Legal").length,
        AIGovernance: policies.filter(p => p.category === "AI Governance").length,
        Overdue: policies.filter(p => p.isOverdue).length,
    };

    const getFilteredPolicies = (tabIndex: number) => {
        let list = policies;
        if (tabIndex === 1) list = policies.filter(p => p.category === "Privacy");
        else if (tabIndex === 2) list = policies.filter(p => p.category === "Security");
        else if (tabIndex === 3) list = policies.filter(p => p.category === "Operational");
        else if (tabIndex === 4) list = policies.filter(p => p.category === "Legal");
        else if (tabIndex === 5) list = policies.filter(p => p.category === "AI Governance");
        else if (tabIndex === 6) list = policies.filter(p => p.isOverdue);

        return list.filter(p => p.title.toLowerCase().includes(searchTerm.toLowerCase()));
    };
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    return (
        <>
            {/* ===== Page Title ===== */}
            <div className="main_title d_flex">
                <div className="left_s">
                    <h1>Trust & Compliance Policies</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                        Trust & Compliance Policies
                    </p>
                </div>
                <div className="right_s form">
                    <Button
                        className="btn btn_primary"
                        onClick={() => setOpenModal(true)}
                    >
                        <AddIcon /> Add Policy
                    </Button>
                </div>
            </div>

            {/* ===== Stats Cards ===== */}
            <div className="stats_boxes gap_m">
                {/* Policies at Risk */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            3
                            <p>Total Policies</p>
                        </h2>
                        <figure className="danger">
                            <ShieldOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight">
                        <small>• 1 Under review</small>
                        <br />
                        <small>• 2 Draft policies pending review</small>
                    </div>
                </div>

                {/* AI Governed Policies */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            5
                            <p>AI Governed Policies</p>
                        </h2>
                        <figure className="sucess">
                            <SmartToyOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight">
                        <small>• 2 Require Public Disclosure</small>
                        <br />
                        <small>• +1 AI Usage Policy recently added</small>
                    </div>
                </div>

                {/* Upcoming Deadlines */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            4
                            <p>Upcoming Deadlines</p>
                        </h2>
                        <figure className="warning_bg" style={{ backgroundColor: '#d4a017' }}>
                            <BusinessCenterOutlinedIcon fontSize="large" style={{ color: '#fff' }} />
                        </figure>
                    </div>
                    <div className="ai_insight">
                        <small>• PDPL Update Due in 8 Days</small>
                        <br />
                        <small>• Vendor Policy Review in 5 Days</small>
                    </div>
                </div>

                {/* Vendor Non-Compliant */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            7
                            <p>Draft Policies</p>
                        </h2>
                        <figure className="active_order">
                            <GavelOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight info">
                        <span>0 policies under review</span>
                        <br />
                        <button className="view_vendors_btn" style={{ background: 'none', border: 'none', color: '#B5651D', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', padding: 0 }}>View All policies</button>
                    </div>
                </div>
            </div>

            {/* ===== Tabs Section ===== */}
            <Box className="custom_tabs mt_20">
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    className="custom_tabs_links"
                >
                    <Tab label={`All Policies (${counts.All})`} {...a11yProps(0)} />
                    <Tab label={`Privacy (${counts.Privacy})`} {...a11yProps(1)} />
                    <Tab label={`Security (${counts.Security})`} {...a11yProps(2)} />
                    <Tab label={`Operational (${counts.Operational})`} {...a11yProps(3)} />
                    <Tab label={`Legal (${counts.Legal})`} {...a11yProps(4)} />
                    <Tab label={`AI Governance (${counts.AIGovernance})`} {...a11yProps(5)} />
                    <Tab label={`Overdue (${counts.Overdue})`} {...a11yProps(6)} />
                </Tabs>
            </Box>

            {/* ===== Tab Panels ===== */}
            {[0, 1, 2, 3, 4, 5, 6].map((index) => (
                <CustomTabPanel value={tabValue} index={index} key={index}>
                    <div className="table_flex">
                        <div className="lt">

                            <div className="cards">
                                <div className="table_header">
                                    <div className="left_s">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search policies..."
                                        />
                                    </div>

                                    <div className="right_s form">
                                        <Select size="small" value="All">
                                            <MenuItem value="All">All Status</MenuItem>
                                            <MenuItem value="Active">Active</MenuItem>
                                            <MenuItem value="Review">Under Review</MenuItem>
                                        </Select>

                                        <Button
                                            className="btn btn_primary"
                                            onClick={() => setOpenModal(true)}
                                        >
                                            <AddIcon /> Add
                                        </Button>
                                    </div>
                                </div>

                                {/* ===== Policy List ===== */}
                                <div className="policies_div mt_20">
                                    {getFilteredPolicies(index).length > 0 ? (
                                        getFilteredPolicies(index).map((policy, i) => (
                                            <div className="policy_row" key={i} onClick={() => handleRowClick(policy)} style={{ cursor: 'pointer' }}>
                                                <div className="left">
                                                    <div className="policy_icon">
                                                        {policy.icon}
                                                    </div>

                                                    <div className="policy_info">
                                                        <div className="title_row">
                                                            <b>{policy.title}</b>
                                                            <span className="code">{policy.code}</span>

                                                            <span className={`status_chip ${policy.status.toLowerCase().replace(" ", "")}`}>
                                                                {policy.status}
                                                            </span>

                                                            <span className={`status_chip ${policy.isOverdue ? "danger" : "active"}`}>
                                                                {policy.review}
                                                            </span>
                                                        </div>

                                                        <p>{policy.description}</p>

                                                        <small>
                                                            {policy.owner} · {policy.version} · Effective: {policy.effective}
                                                        </small>
                                                    </div>
                                                </div>

                                                <div className="actions">
                                                    <IconButton className="btn_view" onClick={(e) => { e.stopPropagation(); setOpenModal(true); }}><EditOutlinedIcon /></IconButton>
                                                    <IconButton className="btn_view" onClick={(e) => { e.stopPropagation(); /* delete logic here if any */ }}><DeleteOutlineOutlinedIcon /></IconButton>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <Box className="no_data_box" py={5} textAlign="center">
                                            <InfoOutlinedIcon sx={{ fontSize: 48, color: "text.secondary", mb: 2 }} />
                                            <p>No policies found in this category.</p>
                                        </Box>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="rt">
                            <div className="ai_panel">
                                <h4>AI Insights</h4>

                                <div className="ai_alert warning">
                                    <span className="icon">⚠️</span>
                                    <p>
                                        <b>7 SKUs</b> need immediate attention
                                    </p>
                                </div>

                                <div className="ai_alert danger">
                                    <span className="icon">⛔</span>
                                    <p>
                                        <b>3 SKUs</b> have zero sales in 30 days
                                    </p>
                                </div>

                                <small className="ai_update">
                                    Next updated ETA: <b>May 5, 2024</b>
                                </small>

                                <div className="ai_sku_list">
                                    <div className="ai_sku_row">
                                        <div className="ai_sku_info">
                                            <h5>#PRD_002</h5>
                                            <p>Likely to go out of stock by May</p>
                                        </div>
                                        <button className="ai_action_btn">Actions ▾</button>
                                    </div>

                                    <div className="ai_sku_row">
                                        <div className="ai_sku_info">
                                            <h5>#PRD_010</h5>
                                            <p>Likely to go out of stock by May</p>
                                        </div>
                                        <button className="ai_action_btn">Actions ▾</button>
                                    </div>
                                </div>

                                {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                            </div>
                        </div>
                    </div>
                </CustomTabPanel>
            ))}
            <NewPolicy
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
            <ViewPolicyDetail
                open={openViewModal}
                onClose={() => setOpenViewModal(false)}
                policy={selectedPolicy}
            />
        </>
    );
};

export default ComlpliancePolicies;
